import css from './index.module.css';

export default function Landing() {
  return (
    <div className={css.body}>
      <div className={css.bodyContent}>
        <h1>Рыбный мир</h1>
        <p className={css.desk}>Интернет-магазин</p>

        <div className={css.btns}>
          <a className={css.btn} href='/assets/app.apk'>
            Скачать для Android
          </a>
          
          <a href={`/webapp`} className={css.btnBlack}>
            Открыть веб-версию
          </a>
        </div>
      </div>
    </div>
  )
}